import React from "react";

const ConfigurationListsContext = React.createContext({
  professionsList: [],
  jobExtentList: [],
  areasList: [],
  users: [],
});

export default ConfigurationListsContext;
